import { render, staticRenderFns } from "./productConfig.vue?vue&type=template&id=666919a3&scoped=true&"
import script from "./productConfig.vue?vue&type=script&lang=js&"
export * from "./productConfig.vue?vue&type=script&lang=js&"
import style0 from "./productConfig.vue?vue&type=style&index=0&id=666919a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666919a3",
  null
  
)

export default component.exports